import { z } from "zod";

export const driversHistoryByVehicleResponseSchema = z.array(
  z.object({
    driverUuid: z.uuid(),
    vehicleUuid: z.uuid(),
    startOfUsage: z.coerce.date(),
    endOfUsage: z.coerce.date().nullable(),
  }),
);

export type DriversHistoryByVehicleResponse = z.infer<
  typeof driversHistoryByVehicleResponseSchema
>;
